module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0072.jpg?v=3a237bba";